"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import { Text } from "@/elements"
import { SendIcon } from "@/icons/outline/SendIcon"
import clsx from "clsx"
import { OpenEnvelopeIcon } from "@/icons/outline/OpenEnvelopeIcon"
import { DefaultJobsFeedItem } from "./DefaultJobsFeedItem"
import { CompactJobsFeedItem } from "./CompactJobsFeedItem"

// viewerRedactionReason is required to be able to show the redacted state of the job post
const JobsFeedItemFragment = graphql(`
  fragment JobsFeedItem on JobPosting {
    id
    __typename
    viewerRedactionReason
    position {
      id
    }
    coverImage {
      id
      thumbnailUrl645: thumbnailUrl(width: 645)
    }
    ...DefaultJobsFeedItem
    ...CompactJobsFeedItem
  }
`)

interface Props {
  jobPost: FragmentType<typeof JobsFeedItemFragment> | null | undefined
  jobIndex: number
  onClick?: (
    jobPostingId: string,
    jobPostingType: "client" | "creative",
    hasImage: boolean,
    positionId: string,
    index: number,
    redacted: boolean
  ) => void
  selected: boolean
  variant: "default" | "compact"
}

export const JobsFeedItem: React.FC<Props> = props => {
  const jobPost = useFragment(JobsFeedItemFragment, props.jobPost)
  const { onClick, jobIndex, selected, variant = "default" } = props

  const image = jobPost?.coverImage?.thumbnailUrl645

  return (
    <div
      style={{ borderWidth: 1.5 }}
      className={clsx(
        "group w-full rounded-xl border border-bg-3 bg-bg-1 p-6 transition-shadow duration-300",
        Boolean(onClick) && "cursor-pointer hover:shadow-[0px_4px_24px_0px_rgba(0,0,0,0.10)]",
        selected && "border-primary-3 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.10)]"
      )}
      onClick={() => {
        onClick?.(
          jobPost?.id!,
          jobPost?.__typename === "ClientJobPosting" ? "client" : "creative",
          Boolean(image),
          jobPost?.position?.id!,
          jobIndex,
          jobPost?.viewerRedactionReason !== null
        )
      }}>
      <div className="flex flex-col lg:hidden xl:flex">
        <DefaultJobsFeedItem jobPost={jobPost} />
      </div>
      <div className="hidden lg:flex xl:hidden">
        <CompactJobsFeedItem jobPost={jobPost} />
      </div>
    </div>
  )
}
